import React from 'react';
import FeatureItem from './FeatureItem';

/**
 * רכיב המציג רשימת תכונות
 * @param {string[]} features - מערך של מחרוזות טקסט המייצגות תכונות
 */
const FeatureList = ({ features }) => {
  return (
    <div className="mt-3 sm:mt-4 md:mt-6">
      <ul className="space-y-1.5 sm:space-y-2 md:space-y-3 text-xxs sm:text-xs md:text-sm">
        {features.map((feature, index) => (
          <FeatureItem key={index} text={feature} />
        ))}
      </ul>
    </div>
  );
};

export default FeatureList;